module.exports = __webpack_public_path__ + "static/media/past paper.4e6aec14.svg";